import { initSentryBrowser } from '@flote/sentry-browser';

initSentryBrowser({
  dsn: import.meta.env.VITE_SENTRY_DSN,
  appName: 'flote-delivery-admin',
  environment: import.meta.env.MODE,
  release: import.meta.env.VITE_SENTRY_RELEASE,
  enableReplay: true,
});

import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './App';
import './styles/global.css';

const rootElement = document.getElementById('root');
if (!rootElement) throw new Error('Root element not found');

createRoot(rootElement).render(
  <StrictMode>
    <App />
  </StrictMode>
);
